import React, {useCallback} from 'react';
import {useDropzone} from 'react-dropzone';

export const FileDropZone = ({onFileGiven}) => {
    const onDrop = useCallback(acceptedFiles => {
        // Do something with the files
        console.info({acceptedFiles});
        onFileGiven(acceptedFiles[0]); // pick only one file
        // eslint-disable-next-line
    }, []);
    const {getRootProps, getInputProps} = useDropzone({onDrop});

    return (

        <div id="employee-bulk-upload-csv-drop-zone">

            <div {...getRootProps()}>
                <input {...getInputProps()} />
                {/*{
                  isDragActive ?
                      <p>Drop the files here ...</p> :
                      <p>Drag 'n' drop some files here, or click to select files</p>
              }*/}
                <h1>Drop CSV File Here</h1>
                <h5>or</h5>
                <button className="ui button">Select a file</button>
            </div>
        </div>
    );
};
